export function getSelectedTerm(offers, selectedOfferId) {
  const installments = offers?.installment || [];

  if (selectedOfferId) {
    for (const installment of installments) {
      const match = (installment?.terms || []).find((t) => t?.id === selectedOfferId);
      if (match) return match;
    }
  }

  if (installments.length === 1 && (installments[0]?.terms || []).length === 1) {
    return installments[0].terms[0];
  }

  return null;
}

export function calcMonthlyPayment({ principal, apr, termMonths }) {
  const P = Number(principal) || 0;
  const n = Number(termMonths) || 0;
  const r = (Number(apr) || 0) / 100 / 12;

  if (P <= 0 || n <= 0) return 0;
  if (r === 0) return P / n;

  const factor = Math.pow(1 + r, n);
  return (P * r * factor) / (factor - 1);
}

export function getEstimatedMonthlyPayment({ offers, selectedOfferId, financed, backendMonthly }) {
  const term = getSelectedTerm(offers, selectedOfferId);

  // Fortiva is revolving credit: the estimated initial minimum monthly payment is
  // the financed amount multiplied by the offer's minimum payment factor (a percent).
  // This always wins when present; everything below is fallback.
  const minPaymentPct = Number(term?.fees?.min_payment_pct);
  if (minPaymentPct > 0) return (Number(financed) || 0) * (minPaymentPct / 100);

  // Fallback 1: a value computed by the backend.
  const backend = Number(backendMonthly);
  if (backend > 0) return backend;

  if (!term) return null;

  // Fallback 2: promo monthly premium.
  const promoMonthly = Number(term?.promo?.monthly_premium);
  if (promoMonthly > 0) return promoMonthly;

  // Last resort: amortize over the fixed term.
  const apr = Number(term.apr_max) || Number(term.apr) || 0;
  return calcMonthlyPayment({
    principal: financed,
    apr,
    termMonths: term.term,
  });
}
